import SectionHeading from '@/components/base/SectionHeading';
import { HIGHLIGHTS } from '@/mocks/schedule';

export default function Highlights() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100" aria-labelledby="highlights-heading">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          id="highlights-heading"
          eyebrow="Why Here"
          title="为什么把赛程放在这一个页面"
          desc="不用在群公告、客服消息和往期推文之间来回翻，进度与时间都收在同一个入口里。"
          align="center"
        />

        <div className="mt-12 flex flex-col gap-10 md:gap-14">
          {HIGHLIGHTS.map((h, idx) => {
            const reversed = idx % 2 === 1;
            return (
              <article
                key={h.id}
                className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center"
              >
                <div
                  className={`w-full aspect-[9/6] rounded-lg overflow-hidden border border-background-200 bg-background-50 ${
                    reversed ? 'md:order-2' : ''
                  }`}
                >
                  <img
                    src={h.image}
                    alt={`${h.title}示意图`}
                    title={`爆料大赛 ${h.title}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className={`${reversed ? 'md:order-1 md:pr-2' : 'md:pl-2'}`}>
                  <span className="font-heading text-5xl font-bold text-primary-200">{h.index}</span>
                  <h3 className="mt-3 font-heading text-xl md:text-3xl font-bold text-foreground-950 leading-snug">
                    {h.title}
                  </h3>
                  <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{h.text}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}